import { render, staticRenderFns } from "./AddTeacherDialog.vue?vue&type=template&id=36b2bd89&scoped=true&"
import script from "./AddTeacherDialog.vue?vue&type=script&lang=js&"
export * from "./AddTeacherDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddTeacherDialog.vue?vue&type=style&index=0&id=36b2bd89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2bd89",
  null
  
)

export default component.exports